module.exports = __webpack_public_path__ + "static/media/organization.5f7361cd.svg";